import { Col, Divider, Row, Table, Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import useManageSubscriptions from "./useManageSubscriptions";
import ReviewReceiptModal from "../../components/modals/reviewReceipt";
import AssignSubscriptionModal from "../../components/modals/assignSubscription";
import SubscriptionPaymentsModal from "../../components/modals/subscriptionPayments";
import Permission from "../../components/general/permission/permission";

const { Title } = Typography;

function ManageSubscriptions() {
  const {
    currentPayment,
    currentUsername,
    data,
    handleApprove,
    handleCancel,
    handleReject,
    loading,
    onTableChange,
    reviewModal,
    assignModal,
    handleAssign,
    submittingAssign,
    tableColumns,
    tableParams,
    total,
    // Payments modal
    paymentsModal,
    paymentsSubscriptionId,
    paymentsSubscriptionName,
    handleClosePayments,
  } = useManageSubscriptions();

  return (
    <div>
      <Row justify="space-between" align="middle" style={{ marginTop: "1rem" }}>
        <Col>
          <Title level={4} style={{ margin: 0, color: "#3a6b0a" }}>
            Gestor de Suscripciones
          </Title>
        </Col>
        <Col>
          <Permission requiredPermission="ui:subscriptions:assign">
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={assignModal.openModal}
              style={{
                borderRadius: "8px",
                background: "#81BC3D",
                borderColor: "#81BC3D",
              }}
            >
              Asignar Plan
            </Button>
          </Permission>
        </Col>
      </Row>
      <Divider></Divider>
      <Row gutter={24}>
        <Col span={24}>
          <Table
            loading={loading}
            dataSource={data}
            columns={tableColumns}
            pagination={{
              ...tableParams.pagination,
              total,
            }}
            onChange={onTableChange}
            rowKey={(record: any) => record.id}
          />
        </Col>
      </Row>
      <ReviewReceiptModal
        handleApprove={handleApprove}
        handleReject={handleReject}
        handleCancel={handleCancel}
        isModalOpen={reviewModal.isModalOpen}
        loading={reviewModal.isLoading}
        payment={currentPayment}
        username={currentUsername}
      />
      <AssignSubscriptionModal
        visible={assignModal.isModalOpen}
        onCancel={assignModal.closeModal}
        onSubmit={handleAssign}
        confirmLoading={submittingAssign}
      />
      <SubscriptionPaymentsModal
        visible={paymentsModal.isModalOpen}
        subscriptionId={paymentsSubscriptionId}
        subscriptionName={paymentsSubscriptionName}
        onCancel={handleClosePayments}
      />
    </div>
  );
}

export default ManageSubscriptions;
